import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
  loaderDurationMs: number;
  pageType: string;
  url: string;
};

class PageViewTrackingEvent extends UserEvent<EventData> {
  collectServerEvents() {
    this.serverEvents.push({
      data: {
        loader_duration_ms: this.data.loaderDurationMs,
        page_type: this.data.pageType,
        url: this.data.url
      },
      type: 'page_view'
    });
  }
}

export default PageViewTrackingEvent;
